import OutlineCard from '@/organisms/cards/OutlineCard/OutlineCard';
import ScenarioList from '@/organisms/scenarios/ScenarioList/ScenarioList';

const ScenarioListCard = ({ entityType, redirectToComparison }) => {
  return (
    <OutlineCard>
      <ScenarioList
        entityType={entityType}
        redirectToComparison={redirectToComparison}
      />
    </OutlineCard>
  );
};
export default ScenarioListCard;
